import { connect } from 'react-redux';
import { questionKey } from '../response/reducer';
import PureHiddenInput from './PureHiddenInput';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  const value = question.rows[ownProps.rowIndex].value;
  return {
    value: value === '' ? value : `rating${value}`,
  };
};

const MatrixHiddenInput = connect(mapStateToProps)(PureHiddenInput);

export default MatrixHiddenInput;
